export const defaultSurveyJson = {
  title: "Customer Agreement",
  logo: "data:image/png;base64,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",
  logoWidth: "72px",
  logoHeight: "72px",
  logoFit: "none",
  focusFirstQuestionAutomatic: true,
  completedHtml: "",
  completedBeforeHtml: "",
  loadingHtml: "<h3>Loading Customer Agreement...</h3>",
  pages: [
    {
      name: "page1",
      elements: [
        {
          type: "text",
          name: "businessName",
          title: "Business name",
          description: "Ex.: XX Pizza (NW15 3AS)",
          descriptionLocation: "underInput",
          isRequired: true,
          requiredErrorText: "Business name is required",
          placeholder: "Type here...",
        },
        {
          type: "panel",
          name: "clientDetailsPanel",
          title: "Client Details",
          elements: [
            {
              type: "text",
              name: "firstName",
              maxWidth: "50%",
              title: "First name",
              isRequired: true,
              requiredErrorText: "First name name is required",
              placeholder: "Type here...",
            },
            {
              type: "text",
              name: "lastName",
              maxWidth: "50%",
              startWithNewLine: false,
              title: "Last name",
              isRequired: true,
              requiredErrorText: "Last name is required",
              placeholder: "Type here...",
            },
            {
              type: "text",
              name: "email",
              title: "Email",
              isRequired: true,
              requiredErrorText: "Email is required",
              inputType: "email",
              placeholder: "Type here...",
            },
            {
              type: "text",
              name: "workNumber",
              startWithNewLine: false,
              title: "Phone Number",
              defaultValue: "+44",
              isRequired: true,
              inputType: "tel",
              placeholder: "Type here...",
            },
          ],
        },
        {
          type: "panel",
          name: "businessPanel",
          title: "Business Details",
          elements: [
            {
              type: "text",
              name: "streetAddress",
              title: "Street Address",
              isRequired: true,
              requiredErrorText: "Street Address is required",
              placeholder: "Type here...",
            },
            {
              type: "text",
              name: "city",
              title: "City",
              isRequired: true,
              requiredErrorText: "City is required",
              placeholder: "Type here...",
            },
            {
              type: "text",
              name: "postcode",
              startWithNewLine: false,
              title: "Postcode",
              isRequired: true,
              requiredErrorText: "Postcode is required",
              placeholder: "Type here...",
            },
            {
              type: "text",
              name: "businessPhoneNumber",
              startWithNewLine: false,
              title: "Business Phone Number",
              defaultValue: "+44",
              inputType: "tel",
              placeholder: "Type here...",
              validators: [
                {
                  type: "text",
                  minLength: 6,
                  text: "Please enter a phone number with at least 5 digits.",
                },
              ],
            },
          ],
        },
        {
          type: "matrixdropdown",
          name: "feeTable",
          title: "Fee Table",
          description:
            "• In addition to fees and product subscription, this contract may include hardware purchases detailed in the sales order and invoice. \n• £0.75 End-user fees are paid by customer and not the business.\n• All fees are exclusive of VAT.",
          descriptionLocation: "underInput",
          columns: [
            {
              name: "term",
              title: "Term",
              cellType: "dropdown",
              minWidth: "10px",
              choices: [
                "No",
                "Rolling 30 Days",
                "12 Months",
                "24 Months",
                "36 Months",
                "48 Months",
              ],
              storeOthersAsComment: true,
            },
            {
              name: "rate",
              title: "Rate",
              cellType: "dropdown",
              minWidth: "10px",
              choices: [
                "£0.00",
                "1% + £0.10",
                "1.6% + £0.20",
                "1.4% + £0.10",
                "5%",
                "6%",
                "7%",
                "8%",
                "9%",
                "10%",
                "22%",
                "24%",
                "26%",
              ],
              showOtherItem: true,
              otherText: "Custom rate",
            },
            {
              name: "setupFee",
              title: "Setup Fee",
              cellType: "dropdown",
              minWidth: "10px",
              choices: ["£0.00", "£150.00", "£200", "£399"],
              showOtherItem: true,
              otherText: "Custom amount",
            },
          ],
          rows: [
            {
              value: "onlineOrders",
              text: "Online orders",
            },
            {
              value: "kiosk",
              text: "GrubKiosk",
            },
            {
              value: "pointOfSale",
              text: "GrubPos",
            },
          ],
          hideIfRowsEmpty: true,
        },
        {
          type: "comment",
          name: "description",
          title: "Description",
          descriptionLocation: "underInput",
          placeholder: "Type here...",
        },
        {
          type: "checkbox",
          name: "requests",
          title: "Business Requests",
          choices: [
            {
              value: "website",
              text: "Website",
            },
            {
              value: "googlePage",
              text: "Google Page",
            },
            {
              value: "flyer",
              text: "Flyer",
            },
          ],
          colCount: 3,
        },
        {
          type: "file",
          name: "menu",
          title: "Menu",
          description:
            "Supported file formats: PDF, JPG, JPEG, PNG, CSV, XSLX, DOCX, PPTX",
          descriptionLocation: "underInput",
          allowMultiple: true,
          maxSize: 157286400,
          filePlaceholder:
            "Drag and drop a file here or click the button below to select a file to upload.",
          acceptedTypes:
            "application/pdf,image/jpeg,image/png,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation",
        },
        {
          type: "html",
          name: "termsAndConditions",
          html: '<ul>\n  <li>\n    <span class="size"\n      >End user fees are subject to change without prior notice. All fees are\n      exclusive of VAT.</span\n    ><br />\n  </li>\n  <li>\n    <span class="size"\n      >The client acknowledges and agrees that they are responsible for paying\n      apple developer account fee which is required for iOS app.</span\n    ><br />\n  </li>\n  <li>\n    <span class="size"\n      ><span class="size"\n        >Client pays the commission fee of gross sale amount of all online\n        orders orders paid online.</span\n      ></span\n    ><br />\n  </li>\n  <li>\n    <span\n      >In the event that customer wishes to terminate the terms of Service\n      earlier than is required, an early termination fee of 100% of the total\n      fee payable for the reminder of the agreed term shall be\n      immediately&nbsp;payable to Grub24uk ltd.</span\n    >\n  </li>\n  <li>\n    <span class="size"\n      ><span class="size"\n        ><span class="size"\n          >Grub24 standard terms and conditions apply. The Customer confirms,\n          through its duly authorised representative, that it accepts the Grub24\n          standard terms and conditions, located at&nbsp;</span\n        ><a\n          href="https://grub24.co.uk/page-terms-and-conditions"\n          target="_blank"\n          rel="noopener noreferrer"\n          ><span class="size"\n            >https://grub24.co.uk/page-terms-and-conditions</span\n          ></a\n        ></span\n      ></span\n    ><br />\n  </li>\n  <li>\n    <span class="size"\n      >This agreement constitutes an ongoing lease option arrangement for the provision of the following equipments.</span\n    ><br />\n  </li>\n  <li>\n    <span class="size"\n      >The customer shall make an initial payment as specified in the description, followed by weekly payments as detailed therein. All equipment shall remain the sole property of Grub24UK Limited until all payments have been made in full and the contractual term has been successfully completed.</span\n    ><br />\n  </li>\n</ul>',
        },
        {
          type: "dropdown",
          name: "grub24SalesOwnerName",
          title: "Grub24 sales owner name",
          isRequired: true,
          requiredErrorText: "Grub24 sales owner name is required",
        },
        {
          type: "text",
          name: "dateTime",
          title: "Date and Time",
          isRequired: true,
          requiredErrorText: "Date and Time is required",
          inputType: "datetime-local",
          min: "2024-01-01T00:00",
        },
        {
          type: "signaturepad",
          name: "businessOwnerSignature",
          title: "Business Owner",
          // isRequired: true,
          requiredErrorText: "Business Owner Signature is required",
        },
        {
          type: "signaturepad",
          name: "grub24SalesOwnerSignature",
          startWithNewLine: false,
          title: "Grub24 Sales Owner",
          isRequired: true,
          requiredErrorText: "Grub24 Sales Owner Signature is required",
        },
      ],
    },
  ],
  showPrevButton: false,
  completeText: "Submit",
  widthMode: "responsive",
  width: "900px",
};
